"use client";

import { IBlogTag } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import BoxWithTitle from "../BoxWithTitle";
import Tag from "./Tag";

interface props {
  tages: IBlogTag[];
  title: string;
}
const TagsBox: React.FC<props> = ({ tages, title }) => {
  if (!tages || tages?.length === 0) return null;
  return (
    <BoxWithTitle title={title}>
      <ul className="tags m-0 p-0" style={{ listStyleType: "none" }}>
        {tages?.map((tag) => (
          <li key={tag.key}>
            <Tag tag={tag} fkey="tags" />
          </li>
        ))}
      </ul>
    </BoxWithTitle>
  );
};
export default TagsBox;
